export default __webpack_public_path__ + "static/media/import-min.e56ff16e.png";